import react from 'react';
import {Link} from 'react-router-dom';

export class PrevSettings extends react.Component {
  render() {
    return <div className="prev-settings">
        {this.props.children}
    </div>
  }
}

export class PrevSettingsContent extends react.Component {
  constructor(props) {
    super(props);
  //  this.props = props;
   // this.store = props.store;
   // let roverDataCompleted = this.store.getState().rover.length && this.store.getState().rover.turningRadius && this.store.getState().rover.wheelDistance;
    this.state = { header: props.header, link: props.link };
  }

  render() {
    return <div className="setting-container">
        <div className="setting-head">
          <h5 className="heading">{this.state.header}</h5>
          <Link to={this.state.link} className="btn btn-sm btn-outline-secondary mx-0">Edit</Link>
        </div>
        <div className="setting-body">
          {this.props.children}
        </div>
      </div>
  }
}

export class PrevSettingsItem extends react.Component {
  constructor(props) {
    super(props);
    this.state = { name: props.name, value: props.value, unit: props.unit  };
  }

  render() {
    return <>
      <div className='col-label'>
        {this.state.name}:
      </div>
      <div className='col-value'>
          {this.state.value} {this.state.unit}
      </div>
    </>
  }
}


/*<div className="prev-settings">
<div className="setting-container">
  <div className="setting-head">
    <h5 className="heading">Rover</h5>
    <Link to={Pages.Rover} className="btn btn-sm btn-outline-secondary">Edit</Link>
  </div>
  <div className="setting-body">
    <p>Wheel Distance: <span id="roverWidth">{this.store.getState().rover.wheelDistance}</span> m</p>
    <p>Length: <span id="roverLength">{this.store.getState().rover.length}</span> m</p>
    <p>Turning radius: <span id="turningRadius">{this.store.getState().rover.turningRadius}</span> m</p>
  </div>
</div>
</div>*/


/*class App extends React.Component{
  constructor(props) {
    super(props);
    this.store = props.store;
  }

  render() {
  return (
    <>
      <div className="topbar">
        <a href=""><img src="/brand.png" alt="GNSS Route Planning logo"></img></a>
        <a href="https:/www.navmatix.com" target="_blank" rel="noopener"><img src="author.png" alt="Navmatix logo"></img></a>
      </div>
    </>
  );
  }
}

export default App;*/



